import type { i18n as I18nInstance } from 'i18next';

import i18n from '@/i18n/i18n';

import { Tenant } from '@/types/common';
import { Language } from '@/types/i18n';

import { applyMergedTenantResources } from './translations';

const loads = new Map<string, Promise<void>>();

function cacheKey(tenant: Tenant, language: Language): string {
  return `${tenant}:${language}`;
}

export function ensureTenantTranslations(
  tenant: Tenant,
  language: Language,
  i18nInstance: I18nInstance = i18n,
): Promise<void> {
  const key = cacheKey(tenant, language);
  const cached = loads.get(key);
  if (cached !== undefined) {
    return cached;
  }

  const promise = applyMergedTenantResources(
    i18nInstance,
    tenant,
    language,
  ).catch(() => undefined);
  loads.set(key, promise);
  return promise;
}

export function suspendUntilTenantTranslations(
  tenant: Tenant,
  language: Language,
  i18nInstance: I18nInstance = i18n,
): void {
  throw ensureTenantTranslations(tenant, language, i18nInstance);
}

/** @internal */
export function resetTenantTranslationLoaderForTests(): void {
  loads.clear();
}
